/**
 * ヘッダードロップダウンメニュー
 * SP（768px以下）: クリックで開閉
 * PC（769px以上）: ホバーで開閉
 */
export const headerDropDown = () => {
  const dropDownItems = document.querySelectorAll('.jsHeaderDropDown');

  if (!dropDownItems.length) return;

  // 画面幅がSPかどうかを判定
  // const isSP = () => window.innerWidth <= 768;
  // iPadPro幅対応
  const isTablet = () => window.innerWidth <= 1024;

  // 全てのドロップダウンを閉じる関数
  const closeAllDropDowns = () => {
    dropDownItems.forEach((item) => {
      const button = item.querySelector('button');
      item.classList.remove('is-open');
      if (button) {
        button.setAttribute('aria-expanded', 'false');
      }
    });
  };

  // ドロップダウンを開く関数
  const openDropDown = (item) => {
    const button = item.querySelector('button');
    item.classList.add('is-open');
    if (button) {
      button.setAttribute('aria-expanded', 'true');
    }
  };

  // ドロップダウンを閉じる関数
  const closeDropDown = (item) => {
    const button = item.querySelector('button');
    item.classList.remove('is-open');
    if (button) {
      button.setAttribute('aria-expanded', 'false');
    }
  };

  // 各ドロップダウンアイテムに対して処理
  dropDownItems.forEach((item) => {
    const button = item.querySelector('button');
    const btnWrapper = item.querySelector('.jsHeaderDropDown__btn');
    const subMenu = item.querySelector('.subMenu');

    if (!button || !btnWrapper || !subMenu) return;

    // ボタンクリックでドロップダウンを開閉（SP用）
    button.addEventListener('click', (e) => {
      // SP時のみクリック動作を有効化
      if (isTablet()) {
        e.preventDefault();
        e.stopPropagation();

        const isOpen = item.classList.contains('is-open');

        // 他の開いているメニューを閉じる
        closeAllDropDowns();

        // 現在のメニューをトグル
        if (!isOpen) {
          openDropDown(item);
        }
      }
    });

    // マウスホバーでドロップダウンを開く（PC用）
    btnWrapper.addEventListener('mouseenter', () => {
      if (!isTablet()) {
        openDropDown(item);
      }
    });

    // マウスが離れたらドロップダウンを閉じる（PC用）
    // subMenu内に入った場合は閉じない
    btnWrapper.addEventListener('mouseleave', (e) => {
      if (!isTablet()) {
        // マウスがsubMenu内に入った場合は閉じない
        if (!subMenu.contains(e.relatedTarget)) {
          closeDropDown(item);
        }
      }
    });

    // subMenuからマウスが離れたらドロップダウンを閉じる（PC用）
    subMenu.addEventListener('mouseleave', (e) => {
      if (!isTablet()) {
        // マウスがbtnWrapper内に入った場合は閉じない
        if (!btnWrapper.contains(e.relatedTarget)) {
          closeDropDown(item);
        }
      }
    });
  });

  // 外側をクリックしたら全て閉じる（SP用）
  document.addEventListener('click', (e) => {
    if (isTablet()) {
      const isClickInsideDropDown = Array.from(dropDownItems).some((item) => {
        return item.contains(e.target);
      });

      if (!isClickInsideDropDown) {
        closeAllDropDowns();
      }
    }
  });

  // Escapeキーで閉じる
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeAllDropDowns();
    }
  });

  // リサイズ時に開いているメニューを閉じる
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      closeAllDropDowns();
    }, 250);
  });
};
